import '/app/brewery-packages/layout/grid-old/src/grid.css-raw';
export default {
  "xwideOffset4": "letter-page-by-username-8d9bc255-xwideOffset4-WXUgJq",
  "confinedOffset7": "letter-page-by-username-8d9bc255-confinedOffset7-WXUgJq",
  "wideOffset10": "letter-page-by-username-8d9bc255-wideOffset10-WXUgJq",
  "xwideOffset6": "letter-page-by-username-8d9bc255-xwideOffset6-WXUgJq",
  "confined9": "letter-page-by-username-8d9bc255-confined9-WXUgJq",
  "xwide9": "letter-page-by-username-8d9bc255-xwide9-WXUgJq",
  "default5": "letter-page-by-username-8d9bc255-default5-WXUgJq",
  "default2": "letter-page-by-username-8d9bc255-default2-WXUgJq",
  "default8": "letter-page-by-username-8d9bc255-default8-WXUgJq",
  "defaultOffset6": "letter-page-by-username-8d9bc255-defaultOffset6-WXUgJq",
  "tinyOffset0": "letter-page-by-username-8d9bc255-tinyOffset0-WXUgJq",
  "confined10": "letter-page-by-username-8d9bc255-confined10-WXUgJq",
  "confinedOffset0": "letter-page-by-username-8d9bc255-confinedOffset0-WXUgJq",
  "wideOffset6": "letter-page-by-username-8d9bc255-wideOffset6-WXUgJq",
  "tiny9": "letter-page-by-username-8d9bc255-tiny9-WXUgJq",
  "xwideOffset10": "letter-page-by-username-8d9bc255-xwideOffset10-WXUgJq",
  "col": "letter-page-by-username-8d9bc255-col-WXUgJq",
  "wide9": "letter-page-by-username-8d9bc255-wide9-WXUgJq",
  "wideOffset1": "letter-page-by-username-8d9bc255-wideOffset1-WXUgJq",
  "wide5": "letter-page-by-username-8d9bc255-wide5-WXUgJq",
  "wideOffset8": "letter-page-by-username-8d9bc255-wideOffset8-WXUgJq",
  "tiny4": "letter-page-by-username-8d9bc255-tiny4-WXUgJq",
  "xwide0": "letter-page-by-username-8d9bc255-xwide0-WXUgJq",
  "default0": "letter-page-by-username-8d9bc255-default0-WXUgJq",
  "default11": "letter-page-by-username-8d9bc255-default11-WXUgJq",
  "xwide8": "letter-page-by-username-8d9bc255-xwide8-WXUgJq",
  "confined8": "letter-page-by-username-8d9bc255-confined8-WXUgJq",
  "defaultOffset10": "letter-page-by-username-8d9bc255-defaultOffset10-WXUgJq",
  "tinyOffset6": "letter-page-by-username-8d9bc255-tinyOffset6-WXUgJq",
  "wide10": "letter-page-by-username-8d9bc255-wide10-WXUgJq",
  "default10": "letter-page-by-username-8d9bc255-default10-WXUgJq",
  "tiny6": "letter-page-by-username-8d9bc255-tiny6-WXUgJq",
  "tinyOffset2": "letter-page-by-username-8d9bc255-tinyOffset2-WXUgJq",
  "xwideOffset2": "letter-page-by-username-8d9bc255-xwideOffset2-WXUgJq",
  "wide3": "letter-page-by-username-8d9bc255-wide3-WXUgJq",
  "xwideOffset11": "letter-page-by-username-8d9bc255-xwideOffset11-WXUgJq",
  "defaultOffset4": "letter-page-by-username-8d9bc255-defaultOffset4-WXUgJq",
  "confined0": "letter-page-by-username-8d9bc255-confined0-WXUgJq",
  "wide7": "letter-page-by-username-8d9bc255-wide7-WXUgJq",
  "confinedOffset2": "letter-page-by-username-8d9bc255-confinedOffset2-WXUgJq",
  "xwide4": "letter-page-by-username-8d9bc255-xwide4-WXUgJq",
  "tiny5": "letter-page-by-username-8d9bc255-tiny5-WXUgJq",
  "wideGridContainer": "letter-page-by-username-8d9bc255-wideGridContainer-WXUgJq",
  "xwideOffset8": "letter-page-by-username-8d9bc255-xwideOffset8-WXUgJq",
  "xwide2": "letter-page-by-username-8d9bc255-xwide2-WXUgJq",
  "tinyOffset4": "letter-page-by-username-8d9bc255-tinyOffset4-WXUgJq",
  "gridContainer": "letter-page-by-username-8d9bc255-gridContainer-WXUgJq",
  "default12": "letter-page-by-username-8d9bc255-default12-WXUgJq",
  "tinyOffset5": "letter-page-by-username-8d9bc255-tinyOffset5-WXUgJq",
  "default6": "letter-page-by-username-8d9bc255-default6-WXUgJq",
  "xwideOffset1": "letter-page-by-username-8d9bc255-xwideOffset1-WXUgJq",
  "xwideOffset5": "letter-page-by-username-8d9bc255-xwideOffset5-WXUgJq",
  "defaultOffset1": "letter-page-by-username-8d9bc255-defaultOffset1-WXUgJq",
  "confined5": "letter-page-by-username-8d9bc255-confined5-WXUgJq",
  "defaultOffset3": "letter-page-by-username-8d9bc255-defaultOffset3-WXUgJq",
  "confinedOffset8": "letter-page-by-username-8d9bc255-confinedOffset8-WXUgJq",
  "default3": "letter-page-by-username-8d9bc255-default3-WXUgJq",
  "tiny8": "letter-page-by-username-8d9bc255-tiny8-WXUgJq",
  "armstrongGridContainer": "letter-page-by-username-8d9bc255-armstrongGridContainer-WXUgJq",
  "confined1": "letter-page-by-username-8d9bc255-confined1-WXUgJq",
  "wideOffset3": "letter-page-by-username-8d9bc255-wideOffset3-WXUgJq",
  "defaultOffset5": "letter-page-by-username-8d9bc255-defaultOffset5-WXUgJq",
  "grid": "letter-page-by-username-8d9bc255-grid-WXUgJq",
  "confined6": "letter-page-by-username-8d9bc255-confined6-WXUgJq",
  "confinedOffset3": "letter-page-by-username-8d9bc255-confinedOffset3-WXUgJq",
  "standardGridContainer": "letter-page-by-username-8d9bc255-standardGridContainer-WXUgJq",
  "xwide1": "letter-page-by-username-8d9bc255-xwide1-WXUgJq",
  "wideOffset9": "letter-page-by-username-8d9bc255-wideOffset9-WXUgJq",
  "confinedOffset5": "letter-page-by-username-8d9bc255-confinedOffset5-WXUgJq",
  "wideOffset7": "letter-page-by-username-8d9bc255-wideOffset7-WXUgJq",
  "xwideOffset9": "letter-page-by-username-8d9bc255-xwideOffset9-WXUgJq",
  "wide1": "letter-page-by-username-8d9bc255-wide1-WXUgJq",
  "tiny11": "letter-page-by-username-8d9bc255-tiny11-WXUgJq",
  "xwide10": "letter-page-by-username-8d9bc255-xwide10-WXUgJq",
  "tinyOffset11": "letter-page-by-username-8d9bc255-tinyOffset11-WXUgJq",
  "tiny1": "letter-page-by-username-8d9bc255-tiny1-WXUgJq",
  "defaultOffset7": "letter-page-by-username-8d9bc255-defaultOffset7-WXUgJq",
  "xwide3": "letter-page-by-username-8d9bc255-xwide3-WXUgJq",
  "default1": "letter-page-by-username-8d9bc255-default1-WXUgJq",
  "tiny2": "letter-page-by-username-8d9bc255-tiny2-WXUgJq",
  "tinyOffset1": "letter-page-by-username-8d9bc255-tinyOffset1-WXUgJq",
  "wideOffset5": "letter-page-by-username-8d9bc255-wideOffset5-WXUgJq",
  "xwide5": "letter-page-by-username-8d9bc255-xwide5-WXUgJq",
  "wide4": "letter-page-by-username-8d9bc255-wide4-WXUgJq",
  "tiny10": "letter-page-by-username-8d9bc255-tiny10-WXUgJq",
  "confined12": "letter-page-by-username-8d9bc255-confined12-WXUgJq",
  "xwide7": "letter-page-by-username-8d9bc255-xwide7-WXUgJq",
  "tinyOffset8": "letter-page-by-username-8d9bc255-tinyOffset8-WXUgJq",
  "confined11": "letter-page-by-username-8d9bc255-confined11-WXUgJq",
  "xwideOffset7": "letter-page-by-username-8d9bc255-xwideOffset7-WXUgJq",
  "defaultOffset9": "letter-page-by-username-8d9bc255-defaultOffset9-WXUgJq",
  "confined4": "letter-page-by-username-8d9bc255-confined4-WXUgJq",
  "tiny0": "letter-page-by-username-8d9bc255-tiny0-WXUgJq",
  "defaultOffset8": "letter-page-by-username-8d9bc255-defaultOffset8-WXUgJq",
  "tinyOffset10": "letter-page-by-username-8d9bc255-tinyOffset10-WXUgJq",
  "default7": "letter-page-by-username-8d9bc255-default7-WXUgJq",
  "tiny12": "letter-page-by-username-8d9bc255-tiny12-WXUgJq",
  "wide11": "letter-page-by-username-8d9bc255-wide11-WXUgJq",
  "row": "letter-page-by-username-8d9bc255-row-WXUgJq",
  "tiny3": "letter-page-by-username-8d9bc255-tiny3-WXUgJq",
  "tiny7": "letter-page-by-username-8d9bc255-tiny7-WXUgJq",
  "xwide11": "letter-page-by-username-8d9bc255-xwide11-WXUgJq",
  "wide12": "letter-page-by-username-8d9bc255-wide12-WXUgJq",
  "wideOffset0": "letter-page-by-username-8d9bc255-wideOffset0-WXUgJq",
  "default4": "letter-page-by-username-8d9bc255-default4-WXUgJq",
  "defaultOffset2": "letter-page-by-username-8d9bc255-defaultOffset2-WXUgJq",
  "confined3": "letter-page-by-username-8d9bc255-confined3-WXUgJq",
  "confined7": "letter-page-by-username-8d9bc255-confined7-WXUgJq",
  "wideOffset4": "letter-page-by-username-8d9bc255-wideOffset4-WXUgJq",
  "wideOffset11": "letter-page-by-username-8d9bc255-wideOffset11-WXUgJq",
  "confinedOffset11": "letter-page-by-username-8d9bc255-confinedOffset11-WXUgJq",
  "default9": "letter-page-by-username-8d9bc255-default9-WXUgJq",
  "tinyOffset7": "letter-page-by-username-8d9bc255-tinyOffset7-WXUgJq",
  "wide0": "letter-page-by-username-8d9bc255-wide0-WXUgJq",
  "wide8": "letter-page-by-username-8d9bc255-wide8-WXUgJq",
  "xwide6": "letter-page-by-username-8d9bc255-xwide6-WXUgJq",
  "xwide12": "letter-page-by-username-8d9bc255-xwide12-WXUgJq",
  "tinyOffset9": "letter-page-by-username-8d9bc255-tinyOffset9-WXUgJq",
  "confinedOffset1": "letter-page-by-username-8d9bc255-confinedOffset1-WXUgJq",
  "confinedOffset6": "letter-page-by-username-8d9bc255-confinedOffset6-WXUgJq",
  "wide2": "letter-page-by-username-8d9bc255-wide2-WXUgJq",
  "defaultOffset11": "letter-page-by-username-8d9bc255-defaultOffset11-WXUgJq",
  "confinedOffset4": "letter-page-by-username-8d9bc255-confinedOffset4-WXUgJq",
  "wide6": "letter-page-by-username-8d9bc255-wide6-WXUgJq",
  "tinyOffset3": "letter-page-by-username-8d9bc255-tinyOffset3-WXUgJq",
  "xwideOffset0": "letter-page-by-username-8d9bc255-xwideOffset0-WXUgJq",
  "xwideOffset3": "letter-page-by-username-8d9bc255-xwideOffset3-WXUgJq",
  "confined2": "letter-page-by-username-8d9bc255-confined2-WXUgJq",
  "confinedOffset9": "letter-page-by-username-8d9bc255-confinedOffset9-WXUgJq",
  "confinedOffset10": "letter-page-by-username-8d9bc255-confinedOffset10-WXUgJq",
  "wideOffset2": "letter-page-by-username-8d9bc255-wideOffset2-WXUgJq"
};